class QuoteCarousel extends HTMLElement {
  constructor() {
    super();
    this.currentIndex = 0;
    this.slides = [];
  }

  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll(".quote-slideshow__slide"));
    this.container = this.querySelector(".quote-slideshow__container");
    this.prevButton = this.querySelector(".quotes__button--prev");
    this.nextButton = this.querySelector(".quotes__button--next");

    if (!this.slides.length) return;

    this.showSlide(this.currentIndex);
    this.setHeight();

    this.prevButton?.addEventListener("click", () => this.prevSlide());
    this.nextButton?.addEventListener("click", () => this.nextSlide());

    window.addEventListener("resize", () => this.setHeight());
  }

  showSlide(index) {
    this.slides.forEach((slide, i) => {
      slide.classList.toggle("active", i === index);
    });
  }

  nextSlide() {
    this.currentIndex = (this.currentIndex + 1) % this.slides.length;
    this.showSlide(this.currentIndex);
    this.setHeight();
  }

  prevSlide() {
    this.currentIndex =
      (this.currentIndex - 1 + this.slides.length) % this.slides.length;
    this.showSlide(this.currentIndex);
    this.setHeight();
  }
  setHeight() {
    // const activeSlide = this.slides[this.currentIndex];
    // requestAnimationFrame(() => {
    //   this.container.style.height = `${activeSlide.offsetHeight}px`;
    // });

    const slideHeights = this.slides.map((slide) => slide.offsetHeight);
    const maxHeight = Math.max(...slideHeights);
    requestAnimationFrame(() => {
      this.container.style.height = `${maxHeight}px`;
    });
  }
}

customElements.define("quote-slideshow", QuoteCarousel);
